module.exports = __webpack_public_path__ + "media/student_v2/assets/images/checkbox/student-alert-checkbox-check-251f9aacc5a97183bd6497e71141c612.svg";